import { render, staticRenderFns } from "./DroppedObjectForm.vue?vue&type=template&id=2db9e612&"
import script from "./DroppedObjectForm.vue?vue&type=script&lang=js&"
export * from "./DroppedObjectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports